module.exports = __webpack_public_path__ + "static/media/departure-icon.5cb49825.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/departure-icon.svg
// module id = 871
// module chunks = 0